const step1Select = document.querySelector('[data-quick-nav-step-1] > select');
const pageLoader = document.querySelector('[data-page-loader]');

export default function initQuickNav() {
    // Quick navigation wizard steps, last step will jump to relevant page
    if (step1Select) {
        step1Select.addEventListener('change', (e) => {
            pageLoader.classList.remove('hidden');
            window.location.href = e.target.value;
        });
    }
}
